import axios, { AxiosInstance, AxiosError } from 'axios'
import { config } from 'config'
import { actions } from 'shared/store'
import { isServerError } from 'shared/utils'
import { SERVER_ERROR_DIALOG_PAYLOAD } from './Api.constants'
import {
  authenticate,
  handleSendLanguageInHeader,
  handleSendAppPlatform,
} from './Api.utils'

const Api: AxiosInstance = axios.create({
  baseURL: config.apiUrl,
})

import('app/App.state').then(({ store }) =>
  Api.interceptors.response.use(undefined, (err: AxiosError) => {
    if (isServerError(err)) {
      store.dispatch(actions.ui.setDialogContent(SERVER_ERROR_DIALOG_PAYLOAD))
      store.dispatch(actions.ui.setDialogOpenState(true))
    }
    throw err.response?.data
  })
)

Api.interceptors.request.use(authenticate)
Api.interceptors.request.use(handleSendLanguageInHeader)
Api.interceptors.request.use(handleSendAppPlatform)

export default Api
